import { DEFAULT_CURRENCY } from "@faire/retailer-visitor-shared/consts/DEFAULT_CURRENCY";
import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { create } from "zustand";

interface RetailerFinancial {
  faireCredit: number;
  currency: string;
  setRetailerFinancial: (retailer: Partial<IRetailer>) => void;
}

export const useZustandRetailerFinancial = create<RetailerFinancial>((set) => ({
  faireCredit: 0,
  currency: DEFAULT_CURRENCY,
  setRetailerFinancial: (retailer) => {
    set({
      faireCredit: retailer.available_balance_cents ?? 0,
      currency: retailer.currency ?? DEFAULT_CURRENCY,
    });
  },
}));

const useRetailerFinancialControl = () => {
  const { faireCredit, currency } = useRetailerStore([
    "faireCredit",
    "currency",
  ]);

  return { faireCredit, currency };
};

export const useRetailerFinancial = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useZustandRetailerFinancial();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useRetailerFinancialControl();
};
